import { render, staticRenderFns } from "./dialogWord.vue?vue&type=template&id=f71430b0&lang=html"
import script from "./dialogWord.vue?vue&type=script&lang=js"
export * from "./dialogWord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports